import React, { useEffect, useRef } from 'react';

export const CredlyBadge = ({ badgeId, width = 150, height = 270 }) => {
    const containerRef = useRef(null);

    // Load the Credly script if not already loaded
    useEffect(() => {
        if (!document.querySelector('script[src*="credly.com"]')) {
            const script = document.createElement('script');
            script.src = '//cdn.credly.com/assets/utilities/embed.js';
            script.async = true;
            script.type = 'text/javascript';
            document.body.appendChild(script);
        }
    }, []);

    useEffect(() => {
        if (containerRef.current && badgeId) {
            // Clear any existing content
            containerRef.current.innerHTML = '';
            
            // Create the badge div
            const badgeDiv = document.createElement('div');
            badgeDiv.setAttribute('data-iframe-width', width);
            badgeDiv.setAttribute('data-iframe-height', height);
            badgeDiv.setAttribute('data-share-badge-id', badgeId);
            badgeDiv.setAttribute('data-share-badge-host', 'https://www.credly.com');
            
            containerRef.current.appendChild(badgeDiv);
            
            // Wait for script to load and initialize
            const initBadge = () => {
                if (window.CredlyBadge && typeof window.CredlyBadge.init === 'function') {
                    window.CredlyBadge.init();
                } else {
                    // Retry after a short delay if script not loaded yet
                    setTimeout(initBadge, 100);
                }
            };
            
            // Start initialization
            setTimeout(initBadge, 100);

            // Defensive: neutralize any full-viewport iframes the Credly script may inject
            const neutralizeOverlays = () => {
                const iframes = Array.from(document.getElementsByTagName('iframe'));
                iframes.forEach((iframe) => {
                    try {
                        const src = iframe.getAttribute('src') || '';
                        // Target Credly iframes or any full-viewport fixed iframe not inside our container
                        const isCredly = src.includes('credly') || src.includes('credly.com');
                        const rect = iframe.getBoundingClientRect();
                        const isFullViewport = rect.width >= window.innerWidth - 1 && rect.height >= window.innerHeight - 1 && getComputedStyle(iframe).position === 'fixed';
                        if ((isCredly || isFullViewport) && containerRef.current && !containerRef.current.contains(iframe)) {
                            // prevent it from intercepting pointer events
                            iframe.style.pointerEvents = 'none';
                            // lower the z-index so our UI stays on top
                            iframe.style.zIndex = '0';
                            // ensure it's not visually covering things unnecessarily
                            // but keep it in the DOM in case Credly expects it
                            // iframe.style.visibility = 'hidden';
                        }
                    } catch (err) {
                        // ignore cross-origin or other access issues
                    }
                });
            };

            const overlayInterval = setInterval(neutralizeOverlays, 200);
            // run once immediately
            neutralizeOverlays();
        }
    }, [badgeId, width, height]);

    // Cleanup: stop any interval and remove any overlay modifications when component unmounts
    useEffect(() => {
        return () => {
            // Remove any pointer-events:none we applied to iframes (best-effort)
            try {
                Array.from(document.getElementsByTagName('iframe')).forEach((iframe) => {
                    if (iframe.style && iframe.style.pointerEvents === 'none') {
                        iframe.style.pointerEvents = '';
                        iframe.style.zIndex = '';
                    }
                });
            } catch (err) {
                // ignore
            }
        };
    }, []);

    if (!badgeId) {
        return null;
    }

    return (
        <div 
            ref={containerRef}
            data-iframe-width={width}
            data-iframe-height={height}
            data-share-badge-id={badgeId}
            data-share-badge-host="https://www.credly.com"
        />
    );
};

